// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Login_PageHolder__2NR58","formHolder":"Login_formHolder__3jvMW","logoHolder":"Login_logoHolder__vpNlG","InputHolder":"Login_InputHolder__1d6eS"};